var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:yekan;src:url(" + escape(require("../assets/BYekan/BYekan+.ttf")) + ") format(\"truetype\");font-weight:400}@font-face{font-family:lalezar;src:url(" + escape(require("../assets/Lalezar-Font/TTF/Lalezar-Regular.ttf")) + ") format(\"truetype\");font-weight:400}@font-face{font-family:lato;src:url(" + escape(require("../assets/Lato-Light.ttf")) + ") format(\"truetype\");font-weight:400}:root{--main-color:#fff;--hover-color:#fafafa;--sub-color:#ef3954;--shrink:#ff8383;--font-color:#696969;--bg-color:#f5f5f5;--heading-color:#fff;--bg-color-1:#ff8383;--font-hover:#d00;--cat:#646464}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/style/var.scss
// module id = 486
// module chunks = 0